import {Component, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {ErrorService} from '../services/error.service';

@Component({
  selector: 'app-error-page',
  imports: [
    RouterLink
  ],
  templateUrl: './error-page.component.html',
  standalone: true,
  styleUrl: './error-page.component.css'
})
export class ErrorPageComponent implements OnInit {
  error: any;
  constructor(private errorService: ErrorService, private router: Router) {
  }
  ngOnInit(): void {
    this.error = this.errorService.getError();
    if (!this.error){
      this.router.navigate(['/crypt']);
    }
  }
}
